import { useQuery } from "react-query";
import { useMusicArchiveEdit } from "frontend/src/domain/music-archives";
import { cacheKey } from "frontend/src/domain/music-archives/shared";
import { getMusicArchiveById } from "frontend/src/api/music-archives";
export var useMusicArchive = function (initial) {
    var musicArchive = useMusicArchiveEdit(initial);
    var change = {
        client: function (client) { var _a; return musicArchive.client_id.set((_a = client === null || client === void 0 ? void 0 : client.id) !== null && _a !== void 0 ? _a : null); },
    };
    var update = function (evt) {
        evt.preventDefault();
        musicArchive.update.run();
    };
    return {
        clientId: { value: musicArchive.client_id.value, onChange: change.client },
        actions: {
            update: {
                run: update,
                pending: musicArchive.update.pending,
            },
            setPublic: {
                run: function () {
                    musicArchive.client_id.set(null);
                }
            }
        },
    };
};
export var useMusicArchiveDetail = function (id) {
    var _a = useQuery([cacheKey, id], function () {
        return getMusicArchiveById(id);
    }), data = _a.data, isFetching = _a.isFetching, isLoading = _a.isLoading, remove = _a.remove;
    return { musicArchive: data, isFetching: isFetching, isLoading: isLoading, remove: remove };
};
